module.exports = __webpack_public_path__ + "static/cashew_nuts_tieu_xanh_0-66d2767d1281a0bbc5afccd809bc1b04.jpg";